// import React from "react";
// import styles from "./Board.module.scss";
// import {BoardNumberByLetter, Colors} from "../../types";
// import { ActionCellData } from "services/WebSocketService/types/ActionCellData";
// import classNames from "classnames/bind";
// import figure from "../Figure/Figure";

// interface CellProps {
//   color: Colors;
//   x: string;
//   y: number;
//   cellClicked: (x: number, y: number) => void;
//   isAvailableForMove?: boolean;
//   isHavingFigure?: boolean;
//   isSelected?: boolean;
//   // isContextActionSquare?: boolean;
//   actionData: ActionCellData | null;
//   isLastMove?: boolean;
//   hasEffectCell: string;
// }

// const Cell: React.FC<CellProps> = (props: CellProps) => {
//   return (
//     <li
//       onClick={() => props.cellClicked(BoardNumberByLetter[props.x], props.y)}
//       id={`cell-${props.x}-${props.y}`}
//       className={classNames(styles.cell, {
//         [styles.cellWhite]: props.color === Colors.WHITE,
//         [styles.cellBlack]: props.color === Colors.BLACK,
//         [styles.availableCell]: props.isAvailableForMove && !props.isHavingFigure,
//         [styles.cellSelected]: props.isSelected,
//         [styles.actionSquare]: Boolean(props.actionData),
//         [styles.cellLastMove]: Boolean(props.isLastMove),
//         // [styles.contextActionSquare] : props.isContextActionSquare,
//       })}
//     >
//       <div
//         className={classNames(styles.cellCircle, {
//           [styles.cellCircleShow]: props.isAvailableForMove && !props.isHavingFigure,
//         })}
//       ></div>
//     </li>
//   );
// };

// export default Cell;

import React from "react";
import styles from "./Cell.module.scss";
import { BoardNumberByLetter, Colors } from "../../types";
import { ActionCellData } from "services/WebSocketService/types/ActionCellData";
import classNames from "classnames";


interface CellProps {
  color: Colors;
  x: string;
  y: number;
  cellClicked: (x: number, y: number) => void;
  isAvailableForMove?: boolean;
  isHavingFigure?: boolean;
  isSelected?: boolean;
  actionData: ActionCellData | null;
  isLastMove?: boolean;
  hasEffectCell?: string;
}

const Cell: React.FC<CellProps> = (props: CellProps) => {
  return (
    <li
      onClick={() => props.cellClicked(BoardNumberByLetter[props.x], props.y)}
      id={`cell-${props.x}-${props.y}`}
      className={classNames(styles.cell, {
        [styles.cellWhite]: props.color === Colors.WHITE,
        [styles.cellBlack]: props.color === Colors.BLACK,
        [styles.availableCell]: props.isAvailableForMove && !props.isHavingFigure,
        [styles.cellSelected]: props.isSelected,
        [styles.actionSquare]: Boolean(props.actionData),
        [styles.cellLastMove]: Boolean(props.isLastMove),
        [styles[`effect-${props.hasEffectCell}`]]: props.hasEffectCell && props.hasEffectCell !== "none",
      })}
    >
      <div
        className={classNames(styles.cellCircle, {
          [styles.cellCircleShow]: props.isAvailableForMove && !props.isHavingFigure,
        })}
      ></div>
    </li>
  );
};

export default Cell;
